import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router';

const messages = defineMessages({
  UNKOWN_PAGE: {
    id: 'NotFound.UNKOWN_PAGE',
    defaultMessage: 'Seite unbekannt',
  },
  PAGE_NOT_FOUND: {
    id: 'NotFound.PAGE_NOT_FOUND',
    defaultMessage: 'Die von Ihnen angewählte Seite konnte leider nicht gefunden werden.',
  },
  BACK_TO_STARTPAGE: {
    id: 'NotFound.BACK_TO_STARTPAGE',
    defaultMessage: 'Zurück zur Startseite',
  },
});

function NotFound({ intl: { formatMessage } }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--bg-color)', padding: '20px' }}>
      <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '12px', boxShadow: '0 4px 6px -1px var(--panel-shadow)', border: '1px solid var(--panel-border)', padding: '40px', maxWidth: '500px', width: '100%', textAlign: 'center', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)' }}>
        <i className="fa fa-map-signs" style={{ fontSize: '48px', color: 'var(--primary-color, #3b82f6)', marginBottom: '24px' }} />
        <h2 style={{ marginTop: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)', marginBottom: '16px' }}>{formatMessage(messages.UNKOWN_PAGE)}</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '16px', lineHeight: '1.5', marginBottom: '32px' }}>
          {formatMessage(messages.PAGE_NOT_FOUND)}
        </p>
        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', backgroundColor: 'var(--primary-color, #3b82f6)', color: '#fff', borderRadius: '8px', textDecoration: 'none', fontWeight: 'bold', transition: 'all 0.2s', boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.4)' }}>
          <i className="fa fa-home" />
          {formatMessage(messages.BACK_TO_STARTPAGE)}
        </Link>
      </div>
    </div>
  );
}

export default injectIntl(NotFound);
